module.exports = __webpack_public_path__ + "assets/img/6.1a13108c.jpg";